import * as Dialog from '@radix-ui/react-dialog'
import { ChatLauncher } from '../ChatLauncher.jsx'
import { ChatPanel } from '../ChatPanel.jsx'
import { useChatLayout } from '../../../context/ChatLayoutContext.jsx'

/**
 * Fullscreen layout - the panel takes the entire viewport. Mobile-first
 * presentation, also used as a "kiosk" mode on desktop when configured.
 */
export function FullscreenLayout({
  conf,
  messages,
  isTyping,
  onSend,
  ochatbot,
  container,
  onLeadFormSubmit,
  onOrderStatusResult,
  ...panelRest
}) {
  const { open, toggleChat, openChat, closeChat } = useChatLayout()

  return (
    <Dialog.Root
      open={open}
      modal={false}
      onOpenChange={(next) => (next ? openChat() : closeChat())}
    >
      <ChatLauncher
        open={open}
        onToggle={toggleChat}
        label={conf?.widgetTitle || 'Chat with us'}
        conf={conf}
      />
      <Dialog.Portal container={container}>
        <Dialog.Content
          aria-describedby={undefined}
          className="fixed inset-0 z-[2147483647]"
        >
          <Dialog.Title className="sr-only">
            {conf?.widgetTitle || 'Chat'}
          </Dialog.Title>
          <ChatPanel
            conf={conf}
            messages={messages}
            isTyping={isTyping}
            onSend={onSend}
            onClose={closeChat}
            ochatbot={ochatbot}
            onLeadFormSubmit={onLeadFormSubmit}
            onOrderStatusResult={onOrderStatusResult}
            {...panelRest}
          />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
